export enum FinishingTypeOption {
    UNKNOWN = 0,
    WITH_FURNITURE = 2,
    FINE = 3,
    WITHOUT_FINISHING = 6,
    PRE_FINISHING = 7
}
